import { Box, Flex, Image, Text, Tooltip } from '@chakra-ui/react';
import PlaceholderBgDefault from 'app/assets/placeholders/avatar.jpeg';
import { User } from 'app/models';
import { Link } from 'react-router-dom';
import styles from './community.module.scss';
import { formatDate } from 'app/utils/date';

interface CommunityItemProps {
  user: User;
  labelId?: string;
}

const findMetric = (entries: any[] = [], labelId?: string) => {
  const byLabel =
    entries.find(item => item?.labelId === labelId) ||
    entries.find(item => item?.labelId === 'all');
  return byLabel;
};

const CommunityItem = ({ user, labelId }: CommunityItemProps) => {
  const {
    username,
    avatar,
    slug,
    canUploadToLabels,
    lastUploadEachLabel,
    totalTracksOrReleasesEachLabel,
  } = user;

  const trackMetrics = findMetric(totalTracksOrReleasesEachLabel, labelId);
  const uploadMetrics = findMetric(lastUploadEachLabel, labelId);

  const totalTracks = trackMetrics?.totalTracks ?? 0;
  const totalReleases = trackMetrics?.totalReleases ?? 0;
  const lastUploadTrack = uploadMetrics?.lastUploadTrack;

  const newCanUploadToLabels = canUploadToLabels.filter(item => item?.isActive);

  return (
    <Box className={styles.contributorItem}>
      <Link to={`/contributors/${slug}`}>
        <Image
          src={avatar || PlaceholderBgDefault}
          fallbacksrc={PlaceholderBgDefault}
          height="276px"
          width="100%"
          objectFit="cover"
          loading="lazy"
        />
        <Box className={styles.contributorName}>{username}</Box>
      </Link>
      <Box w="100%" padding="10px" fontSize="12px">
        {lastUploadTrack && (
          <Flex
            justifyContent="space-between"
            alignItems="center"
            lineHeight="22px"
          >
            <Text>Last Upload:</Text>
            <Text fontWeight="600">{formatDate(lastUploadTrack)}</Text>
          </Flex>
        )}
        <Flex
          justifyContent="space-between"
          alignItems="center"
          lineHeight="22px"
        >
          <Text>Total Tracks:</Text>
          <Text fontWeight="600">{totalTracks}</Text>
        </Flex>
        <Flex
          justifyContent="space-between"
          alignItems="center"
          lineHeight="22px"
        >
          <Text>Total Multipacks:</Text>
          <Text fontWeight="600">{totalReleases}</Text>
        </Flex>
        <Flex
          justifyContent="space-between"
          alignItems="center"
          lineHeight="22px"
        >
          <Text>Labels:</Text>
          <Tooltip
            label={
              <Box>
                {newCanUploadToLabels.map((item, idx) => (
                  <Text key={idx}>{item?.name}</Text>
                ))}
              </Box>
            }
          >
            <Text fontWeight="600">{newCanUploadToLabels.length || 0}</Text>
          </Tooltip>
        </Flex>
      </Box>
    </Box>
  );
};

export default CommunityItem;
